import type { FC } from 'react'
import { Chip, type ChipProps } from '@/components/commons/chip'
import { XCloseIcon } from '@/components/ui/icons'
import type { ExperienceFlag } from '@/features/experience-shell/types.ts'
import { OpsVettingFlagsContainer } from '@/features/ops-vetting/components/ops-vetting-atoms'
import { useTranslation } from '@/translations/i18n'
import { experiencesFlagsMapToLabel } from '../utils'
import {
	ExperienceVettingCriteriaFlagsSelect,
	type ExperienceVettingCriteriaFlagsSelectProps
} from './experience-vetting-criteria-flags-select'

interface ServiceVettingCriteriaFlagsProps
	extends Omit<ExperienceVettingCriteriaFlagsSelectProps, 'selectedFlagsId'> {
	flags: ExperienceFlag[]
	flagPosition?: 'left' | 'right'
	badgeVariant?: ChipProps['variant']
	hideAction?: boolean
}
export const ExperienceVettingCriteriaFlags: FC<
	ServiceVettingCriteriaFlagsProps
> = ({
	flags,
	addFlag,
	removeFlag,
	badgeVariant = 'info',
	scopes,
	hideAction,
	flagPosition = 'right'
}) => {
	const { t } = useTranslation()
	return (
		<OpsVettingFlagsContainer $flagPosition={flagPosition} gap={2}>
			{!hideAction && (
				<ExperienceVettingCriteriaFlagsSelect
					addFlag={addFlag}
					removeFlag={removeFlag}
					scopes={scopes}
					selectedFlagsId={flags.map((flag) => flag.id)}
				/>
			)}
			{flags.map((flag) => (
				<Chip
					endSlot={
						!hideAction && (
							<button
								onClick={() => removeFlag(flag)}
								tabIndex={-1}
								type='button'
							>
								<XCloseIcon />
							</button>
						)
					}
					isActive
					key={flag.id}
					label={t(experiencesFlagsMapToLabel[flag.keyName])}
					variant={badgeVariant}
				/>
			))}
		</OpsVettingFlagsContainer>
	)
}
